import { render, staticRenderFns } from "./traverData.vue?vue&type=template&id=1cc88552"
import script from "./traverData.vue?vue&type=script&lang=js"
export * from "./traverData.vue?vue&type=script&lang=js"
import style0 from "./traverData.vue?vue&type=style&index=0&id=1cc88552&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports